module.exports = __webpack_public_path__ + "img/list_arrow.88ef266e.png";